import { USER_REQUEST,
  USER_ERROR,
  USER_SUCCESS,
  DIARY_DATA,
  CLASSROOM_REQUEST,
  SET_CLASSROOM_LIST, CLEAR_DIARY_DATA,
  SET_DIARY, PUBLISH_DIARY, CHECK_DIARY_DATE, SET_DIARY_DATE,
  UPDATE_STUDENT_DIARY, UPDATE_MENU_DIARY, UPDATE_STUDENT,
  REFRESH_DIARY, CHECK_VERSION, NEW_VERSION_DETECTED
} from '../actions/user'
import { apiAuthCall, getResource } from '@/utils/api'
import { classroomDiary } from '@/utils/endpoints'
import Vue from 'vue'
import { AUTH_LOGOUT } from '../actions/auth'
import packageJson from '@/../package.json'

const isBuildDateGreaterThan = (latestVersion, localVersion) => {
  return latestVersion > localVersion
}

const initialDiaries = () => {
  const storagedClass = JSON.parse(localStorage.getItem('storagedClass') || '[]')
  const diaries = {}
  storagedClass.forEach(classId => {
    diaries[classId] = {
      student: JSON.parse(localStorage.getItem(`diary.${classId}.student`)),
      menu: JSON.parse(localStorage.getItem(`diary.${classId}.menu`))
    }
  })
  return diaries
}

const state = {
  status: '',
  diaryDate: JSON.parse(localStorage.getItem('diaryDate') || null),
  profile: JSON.parse(localStorage.getItem('profile') || '{}'),
  classrooms: undefined,
  diaries: initialDiaries(),
  newVersion: false
}

const getters = {
  getProfile: state => state.profile,
  getClassrooms: state => state.classrooms,
  isProfileLoaded: state => !!state.profile.name
}

const actions = {
  [AUTH_LOGOUT]: ({ commit, state, dispatch }, profile) => {
    localStorage.removeItem('profile')
    dispatch(CLEAR_DIARY_DATA)
  },
  [USER_SUCCESS]: ({ commit, state, dispatch }, profile) => {
    localStorage.setItem('profile', JSON.stringify(profile))
  },
  [CLEAR_DIARY_DATA]: () => {
    localStorage.removeItem('diaryDate')
    const classRooms = JSON.parse(localStorage.getItem('storagedClass') || '[]')
    classRooms.forEach(classRoom => {
      localStorage.removeItem('diary.' + classRoom + '.menu')
      localStorage.removeItem('diary.' + classRoom + '.student')
    })
    localStorage.removeItem('storagedClass')
  },
  [CHECK_VERSION]: ({ commit, state, dispatch }, profile) => {
    return new Promise((resolve, reject) => {
      const url = `${window.location.protocol}//${window.location.hostname}/meta.json?timestamp=${new Date().getTime()}`
      getResource({ url })
        .then(resp => {
          const newVersion = isBuildDateGreaterThan(resp.buildDate, packageJson.buildDate)
          if (newVersion) {
            if ('caches' in window) {
              // Service worker cache should be cleared with caches.delete()
              caches.keys().then((names) => {
                names.forEach((name) => caches.delete(name))
              })
            }
            commit(NEW_VERSION_DETECTED)
          }
          console.log({buildDate: packageJson.buildDate})
          resolve(newVersion)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  [CHECK_DIARY_DATE]: ({ commit, state, dispatch }) => {
    return new Promise(function (resolve, reject) {
      const url = '/api/agendadiaria/currentDiary'
      apiAuthCall({ url, data: {}, method: 'GET' })
        .then(resp => {
          if (state.diaryDate === resp.diaryDate) return resolve({ changed: false })
          commit(SET_DIARY_DATE, resp.diaryDate)
          dispatch(CLEAR_DIARY_DATA)
          localStorage.setItem('diaryDate', JSON.stringify(resp.diaryDate))
          resolve({ changed: true })
        })
        .catch(() => {
          reject(new Error('Agenda no encontrada'))
          dispatch(CLEAR_DIARY_DATA)
        })
    })
  },
  [USER_REQUEST]: ({ commit, dispatch }) => {
    commit(USER_REQUEST)
    const url = '/api/agendadiaria/user'
    apiAuthCall({ url, data: {}, method: 'GET' })
      .then(resp => {
        commit(USER_SUCCESS, resp)
        dispatch(USER_SUCCESS, resp)
      })
      .catch(() => {
        commit(USER_ERROR)
        // if resp is unauthorized, logout, to
        dispatch(AUTH_LOGOUT)
      })
  },
  [REFRESH_DIARY]: ({ commit, state, dispatch }, {classId, type}) => {
    return new Promise((resolve, reject) => {
      classroomDiary(classId)
        .then(resp => {
          const typeName = type === 'menu' ? 'menu' : 'student'
          const oppTypeName = type === 'menu' ? 'student' : 'menu'
          const newDiary = { ...state.diaries[classId] }
          newDiary[typeName] = resp[typeName]
          localStorage.setItem(`diary.${classId}.${typeName}`, JSON.stringify(resp[typeName]))
          if (newDiary[oppTypeName].length === 0) {
            newDiary[oppTypeName] = resp[oppTypeName]
            localStorage.setItem(`diary.${classId}.${oppTypeName}`, JSON.stringify(resp[oppTypeName]))
          }
          commit(SET_DIARY, {classCode: classId, data: newDiary})
          resolve(newDiary)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  [PUBLISH_DIARY]: ({ commit, state, dispatch }, {classId}) => {
    return new Promise((resolve, reject) => {
      const diary = state.diaries[classId]
      // console.log({PUBLISH_DIARY: classId})
      // console.log({PUBLISH_DIARY: diary})
      if (!diary) return reject(new Error('Agenda no encontrada'))
      const url = process.env.API_TEST ? '/publish' : `/api/agendadiaria/classroom/${classId}/students/publish`
      apiAuthCall({ url, data: {diary}, method: 'POST' })
        .then(resp => {
          resolve(resp)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  [DIARY_DATA]: ({ commit, state, dispatch }, classId) => {
    return new Promise((resolve, reject) => {
      if (state.diaries[classId]) {
        return resolve(state.diaries[classId])
      }
      classroomDiary(classId)
        .then(resp => {
          commit(SET_DIARY, { classCode: classId, data: resp })
          localStorage.setItem(`diary.${classId}.menu`, JSON.stringify(resp.menu))
          localStorage.setItem(`diary.${classId}.student`, JSON.stringify(resp.student))

          const classRooms = JSON.parse(localStorage.getItem('storagedClass') || '[]')
          if (!classRooms.includes(classId)) classRooms.push(classId)
          localStorage.setItem('storagedClass', JSON.stringify(classRooms))
          resolve(resp)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  [UPDATE_STUDENT_DIARY]: ({ commit, dispatch, state }, {classId, studentData}) => {
    const diary = state.diaries[classId].student
    const newDiary = { ...state.diaries[classId] }
    newDiary.student = diary.map(child => (child.id === studentData.id) ? studentData.data : child)
    localStorage.setItem(`diary.${classId}.student`, JSON.stringify(newDiary.student))
    commit(UPDATE_STUDENT, {classCode: classId, diary: newDiary})
  },
  [UPDATE_MENU_DIARY]: ({ commit, dispatch, state }, {classId, menuData}) => {
    const diary = state.diaries[classId].menu
    const newDiary = { ...state.diaries[classId] }
    newDiary.menu = diary.map(child => (child.id === menuData.id) ? menuData.data : child)
    localStorage.setItem(`diary.${classId}.menu`, JSON.stringify(newDiary.menu))
    commit(UPDATE_STUDENT, {classCode: classId, diary: newDiary})
  },
  [CLASSROOM_REQUEST]: ({ commit, dispatch }, classId) => {
    return new Promise((resolve, reject) => {
      const url = '/api/agendadiaria/classrooms'
      apiAuthCall({ url })
        .then(resp => {
          commit(SET_CLASSROOM_LIST, resp)
          resolve(resp)
        })
        .catch(err => {
          reject(err)
        })
    })
  }
}

const mutations = {
  [NEW_VERSION_DETECTED]: state => {
    console.log('Nueva detectadaa!!!!!!!')
    state.newVersion = true
  },
  [USER_REQUEST]: state => {
    state.status = 'loading'
  },
  [SET_DIARY_DATE]: (state, diaryDate) => {
    state.diaryDate = diaryDate
  },
  [USER_SUCCESS]: (state, resp) => {
    state.status = 'success'
    Vue.set(state, 'profile', resp)
  },
  [CLEAR_DIARY_DATA]: (state) => {
    state.status = 'success'
    Vue.set(state, 'diaries', {})
  },
  [USER_ERROR]: state => {
    state.status = 'error'
  },
  [CLASSROOM_REQUEST]: state => {
    console.log('testng mutations')
    state.classrooms = undefined
  },
  [SET_DIARY]: (state, {classCode, data}) => {
    state.diaries[classCode] = data
  },
  [UPDATE_STUDENT]: (state, {classCode, diary}) => {
    state.diaries[classCode] = diary
  },
  [SET_CLASSROOM_LIST]: (state, resp) => {
    Vue.set(state, 'classrooms', resp)
    // state.classrooms = resp
  },
  [AUTH_LOGOUT]: state => {
    state.profile = {}
  }

}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/user.js